import { render } from "./LocalPosts.vue?vue&type=template&id=8ee28148&scoped=true"
import script from "./LocalPosts.vue?vue&type=script&lang=js"
export * from "./LocalPosts.vue?vue&type=script&lang=js"

import "../../../../reports/css/modal.css?vue&type=style&index=0&id=8ee28148&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ee28148"]])

export default __exports__